import React from "react";
import { Card, Table, Progress, Tag } from "antd";
import { TeamOutlined } from "@ant-design/icons";

const PlanBreakdown = ({ byPlan }) => {
  // Check if byPlan is a valid non-empty object (not array)
  const isValidObject = byPlan && typeof byPlan === 'object' && !Array.isArray(byPlan) && Object.keys(byPlan).length > 0;

  if (!isValidObject) {
    return (
      <Card
        title={
          <span>
            <TeamOutlined style={{ marginRight: 8, color: "#722ed1" }} />
            Performance by Plan
          </span>
        }
        bordered={false}
        style={{ height: "100%", minHeight: 380 }}
        bodyStyle={{ display: "flex", alignItems: "center", justifyContent: "center", height: "calc(100% - 57px)" }}
      >
        <div style={{ textAlign: "center", color: "#999" }}>
          No plan data available
        </div>
      </Card>
    );
  }

  const dataSource = Object.entries(byPlan).map(([planName, stats]) => ({
    key: planName,
    planName,
    sent: stats?.sent || 0,
    opened: stats?.opened || 0,
    openRate: stats?.openRate || 0,
  }));

  const columns = [
    {
      title: "Plan",
      dataIndex: "planName",
      key: "planName",
      render: (text) => (
        <Tag color="blue" style={{ textTransform: "capitalize" }}>
          {text}
        </Tag>
      ),
    },
    {
      title: "Sent",
      dataIndex: "sent",
      key: "sent",
      align: "center",
      sorter: (a, b) => a.sent - b.sent,
      render: (val) => <span style={{ fontWeight: 500 }}>{val.toLocaleString()}</span>,
    },
    {
      title: "Opened",
      dataIndex: "opened",
      key: "opened",
      align: "center",
      sorter: (a, b) => a.opened - b.opened,
      render: (val) => <span style={{ fontWeight: 500 }}>{val.toLocaleString()}</span>,
    },
    {
      title: "Open Rate",
      dataIndex: "openRate",
      key: "openRate",
      sorter: (a, b) => a.openRate - b.openRate,
      render: (val) => (
        <div style={{ minWidth: 100 }}>
          <Progress
            percent={parseFloat(val.toFixed(1))}
            size="small"
            strokeColor={val >= 50 ? "#52c41a" : val >= 25 ? "#faad14" : "#f5222d"}
          />
        </div>
      ),
    },
  ];

  return (
    <Card
      title={
        <span>
          <TeamOutlined style={{ marginRight: 8, color: "#722ed1" }} />
          Performance by Plan
        </span>
      }
      bordered={false}
      style={{ height: "100%", minHeight: 380 }}
    >
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        size="small"
        scroll={{ y: 280 }}
      />
    </Card>
  );
};

export default PlanBreakdown;
